<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :hot-key-create-path="'/stock-adjustment/create'"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Stock Adjustment"
        :baseView="baseView"
        :primaryLabel="'Stock Adjustment # ' + baseView.id"
        :secondaryLabel="null"
      />
    </template>

    <dx-data-grid
      :data-source="stockAdjustmentDataSourceConfig"
      :ref="'stock-adjustment-grid'"
      :height="gridHeight"
      :column-chooser="{ enabled: false }"
      @cell-prepared="onCellPrepared"
      @toolbar-preparing="onToolbarPreparing($event)"
      :columns="columns"
      key-expr="RecordId"
      validation-group="formsData"
      @content-ready="addGridNoResults($event)"
      v-if="loadingCompleted"
    >
      <DxEditing :allow-updating="true" mode="cell" />

      <template #primaryImageTemplate="{ data }">
        <GcGridProductImage
          :ItemCode="data.data.ItemCode"
          :HasPrimaryImage="data.data.HasPrimaryImage"
          :Description="data.data.ItemDescription"
        />
      </template>

      <template #qtyEditTemplate="{ data: cellInfo }">
        <div>
          <DxNumberBox
            :value="cellInfo.value"
            :disabled="true"
            :format="cellInfo.column.format"
            class="gc-border-bottom-dotted"
            :min="-99999999.99"
            :max="99999999.99"
          />
        </div>
      </template>

      <template #branch-template="{ data }">
        <div class="gc-auto-cmp">
          {{ data.data.BranchDescription }}
        </div>
      </template>

      <template #branchEditTemplate="{ data: cellInfo }">
        <div class="gc-auto-cmp-editor">
          <GcBranchAutoComplete
            :ref="'branch' + cellInfo.rowIndex"
            :data-source="getBranchDataSource()"
            :value="cellInfo.value"
            :cell-info="cellInfo"
            :disabled="true"
            class="gc-border-bottom-dotted"
          />
        </div>
      </template>

      <template #itemBranch="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data.Code }}</span>
          <span class="auto-complete-secondary">{{ data.Description }}</span>
        </div>
      </template>

      <template #menu-cell-template="{ data }">
        <DxDropDownButton
          :items="[{ menuText: 'Line Comment', data: data }]"
          keyExpr="menuText"
          displayExpr="menuText"
          :drop-down-options="{ width: 250 }"
          class="gc-dropdown-icon-button"
          :id="data.data.Code"
          :icon="'overflow'"
          styling-mode="text"
          :show-arrow-icon="false"
          :onItemClick="onItemClick"
          :visible="formsConfig.editableOption"
        />
      </template>

      <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
      <template #masterDetailTemplate="{ data: lineitem }">
        <div>
          <GcBatchStockAdjustment
            :template-data="lineitem"
            :parent-model="model"
            :update-review-list="updateReviewList"
            :brokenGridValidations="brokenGridValidations"
            :allowEdit="false"
          />
        </div>
      </template>
    </dx-data-grid>
    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="350"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'line-comments-form'"
          :customizeItem="customizeLineCommentItem"
          :form-data.sync="lineCommentModel"
          :items="lineCommentItems"
          :label-location="formsConfig.labelPosition"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";

import { DxMasterDetail } from "devextreme-vue/data-grid";
import { BranchService } from "../../_services/api/sales/branch.service";
import { StockAdjustmentReviewService } from "../../_services/api/inventory/stock-adjustment-review.service";
import { StockAdjustmentBatchService } from "../../_services/api/inventory/stock-adjustment-batch.service";

let stockAdjustmentReviewListDataSource = StockAdjustmentReviewService.dataSourceConfig(
  {
    // sort: [{ selector: "ItemCode", asc: true }],
    postProcess: (data) => {
      data.forEach((element) => {
        if (element["IsBatchProduct"] != "No") {
          StockAdjustmentBatchService.getProductBatches(
            element["StockAdjustmentCode"],
            element["LineNo"]
          ).then((response) => {
            element["StockAdjustmentProductBatches"] = response.data.value;
          });
        }
      });
      return data;
    },
    key: "LineNo",
    preventPagination: true,
  }
);

export default {
  mixins: [BaseViewMixin],
  components: {
    DxMasterDetail,
  },
  async created() {
    // let that = this;
    this.showLoading(true);
    await StockAdjustmentReviewService.getByCode(this.baseView.id).then(
      (response) => {
        this.model.DateIn = response.data.value[0].DateIn;
        this.model.DateChanged = response.data.value[0].DateChanged;
        this.model.DateCreated = response.data.value[0].DateCreated;
        this.model.ChangedBy = response.data.value[0].ChangedBy;
        this.model.CreatedBy = response.data.value[0].CreatedBy;

        // that.refreshView();
      }
    );
    stockAdjustmentReviewListDataSource.filter([
      ["StockAdjustmentCode", "=", parseInt(this.baseView.id)],
    ]);
    stockAdjustmentReviewListDataSource.load().then(() => {
      this.stockAdjustmentDataSourceConfig = stockAdjustmentReviewListDataSource.items();
    });
    this.loadingCompleted = true;
    this.showLoading(false);
  },
  data() {
    return {
      stockAdjustmentDataSourceConfig: [],
      brokenGridValidations: [],
      model: {
        DateIn: null,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },
      toolbar: {
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      lineCommentModel: {
        Comment: "",
      },
      lineCommentsPopupVisible: false,
      stockAdjustmentCurrentView: "ProductList",
    };
  },
  methods: {
    updateReviewList(data) {
      const index = stockAdjustmentReviewListDataSource.findIndex(
        (x) => x.Code === data.Code
      );
      if (index > -1) {
        stockAdjustmentReviewListDataSource[index] = data;
      } else {
        stockAdjustmentReviewListDataSource.push(data);
      }
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },

    getBranchDataSource() {
      return BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Description", asc: false }],
      });
    },

    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.command === "expand") {
        if (e.data.IsBatchProduct == "No") {
          e.cellElement.classList.remove("dx-datagrid-expand");
          e.cellElement.childNodes[0].classList.remove(
            "dx-datagrid-group-closed"
          );
        }
      }
    },

    onItemClick(e) {
      if (e.itemData.menuText == "Line Comment") {
        let rowData = e.itemData.data.data;

        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentsPopupVisible = true;
        this.$logger.trackEventOpenPopup(
          "Stock Adjustment Review Line Comment"
        );
        let form = this.$refs["line-comments-form"].instance;
        form.repaint();
      }
    },

    popupLineCommentBackButtonClick() {
      this.lineCommentsPopupVisible = false;
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },

    backButtonFunction() {
      this.$router.push({
        path: "/stock-adjustment",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          options: this.toolbar.audit,
          location: "after",
          widget: "dxButton",
          visible: this.baseView.mode == "review",
        },

        {
          widget: "dxForm",
          location: "before",

          options: {
            readOnly: true,
            formData: this.model,
            items: this.toolbarDetailsFormItems,
            validationGroup: this.formsConfig.validationGroup,
            labelLocation: "left",
            colCount: 2,
          },
          locateinmenu: "auto",
        }
      );
    },
  },
  computed: {
    stockAdjustmentGrid() {
      return this.$refs["stock-adjustment-grid"]
        ? this.$refs["stock-adjustment-grid"].instance
        : null;
    },
    toolbarDetailsFormItems() {
      return this.parseFormColumns([
        {
          dataField: "View",
          gcLabel: " ",
          gcType: "String",
          editorType: "dxSelectBox",
          editorOptions: {
            width: 200,
            items: [
              {
                value: "Review",
                text: "Review",
              },
              {
                value: "ProductList",
                text: "Product",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: "Review",
          },
        },
        {
          dataField: "DateIn",
          gcLabel: "Date Adjusted",
          gcType: "Date",
          width: 120,
        },
      ]);
    },
    lineCommentItems() {
      return this.parseFormColumns([
        {
          dataField: "Comment",
          gcLabel: " ",
          labelVisible: false,
          gcType: "String",
          editorType: "dxTextArea",
          editorOptions: {
            height: "140",
            maxLength: 1000,
            readOnly: true,
          },
        },
      ]);
    },
    columns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Item",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          dataField: "ItemDescription",
          allowEditing: false,
          cellTemplate: "primaryImageTemplate",
        },
        {
          gcLabel: "Item",
          dataField: "ItemCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "ItemDescription",
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Branch",
          dataField: "BranchCode",
          gcType: "String",
          allowFiltering: true,
          allowSorting: false,
          width: 200,
          allowEditing: true,

          validationRules: [
            {
              type: "custom",
              message: "Branch is required",
              validationCallback: this.branchValidator,
            },
          ],
          cellTemplate: "branch-template",
          editCellTemplate: "branchEditTemplate",
        },
        {
          gcLabel: "Branch",
          dataField: "BranchDescription",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "UM",
          dataField: "UnitOfMeasureCode",
          gcType: "String",
          width: 75,
        },

        {
          gcLabel: "Quantity",
          dataField: "AdjustedQty",
          editCellTemplate: "qtyEditTemplate",
          gcType: "Decimal-6-2",
          allowSorting: false,
          showEditorAlways: true,
        },

        {
          gcLabel: "",
          gcType: "String",
          gcSubType: "IconButton",
          cellTemplate: "menu-cell-template",
        },
      ]);
    },
  },
};
</script>

<style></style>
